import { observer } from 'mobx-react-lite'
import { ArticleFlat } from 'types'
import { TemplatePicker } from 'components/TemplatePicker/TemplatePicker'
import templateStore from 'stores/TemplatesStore'
import CreateFromTemplateModal from 'components/CreateFromTemplateModal/CreateFromTemplateModal'

export const TemplatePickerWrapper = observer((props: { article: ArticleFlat }) => {
  return (
    <>
      <TemplatePicker article={props.article} visible={templateStore.isPickerVisible} />

      {templateStore.isTemplateModalOpen && (
        <CreateFromTemplateModal
          visible={templateStore.isTemplateModalOpen}
          onClose={() => templateStore.closeModal()}
        />
      )}
    </>
  )
})
